var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#F5F6F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#clip0_1956_9138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3872 27.4012C16.0999 26.8683 15.9668 26.2659 16.0028 25.6616C16.0389 25.0572 16.2426 24.4749 16.5912 23.9799C17.1609 23.1441 17.9238 22.458 18.8152 21.9799L28.8166 16.7746C29.7996 16.2634 30.8912 15.9966 31.9992 15.9966C33.1072 15.9966 34.1989 16.2634 35.1819 16.7746L45.1819 21.9839C46.0733 22.462 46.8362 23.1481 47.4059 23.9839C47.7545 24.4789 47.9582 25.0612 47.9943 25.6656C48.0303 26.2699 47.8972 26.8723 47.6099 27.4052C47.3006 27.9904 46.8367 28.4794 46.2687 28.8191C45.7007 29.1588 45.0504 29.3362 44.3886 29.3319H19.6099C18.9474 29.3361 18.2966 29.1582 17.7283 28.8177C17.16 28.4773 16.6961 27.9873 16.3872 27.4012V27.4012ZM46.6659 45.3319C46.6659 44.6247 46.3849 43.9464 45.8848 43.4463C45.3847 42.9462 44.7065 42.6652 43.9992 42.6652V31.9986H41.3326V42.6652H37.3326V31.9986H34.6659V42.6652H29.3326V31.9986H26.6659V42.6652H22.6659V31.9986H19.9992V42.6652C19.292 42.6652 18.6137 42.9462 18.1136 43.4463C17.6135 43.9464 17.3326 44.6247 17.3326 45.3319C16.9789 45.3319 16.6398 45.4724 16.3897 45.7224C16.1397 45.9725 15.9992 46.3116 15.9992 46.6652C15.9992 47.0189 16.1397 47.358 16.3897 47.6081C16.6398 47.8581 16.9789 47.9986 17.3326 47.9986H46.6659C47.0195 47.9986 47.3586 47.8581 47.6087 47.6081C47.8587 47.358 47.9992 47.0189 47.9992 46.6652C47.9992 46.3116 47.8587 45.9725 47.6087 45.7224C47.3586 45.4724 47.0195 45.3319 46.6659 45.3319Z",
    fill: "#9394A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1956_9138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBank);
export default __webpack_public_path__ + "static/media/default-bank.f6f65dde.svg";
export { ForwardRef as ReactComponent };